import * as Yup from 'yup';

const emailUpdateSchema = Yup.object().shape({
    ftm_email: Yup.string().email('Invalid email').required('Email is required'),
});

export default emailUpdateSchema;
